module.exports = __webpack_public_path__ + "static/media/coverpage-01.babec4dc.png";